"use client";
import Link from "next/link";
import { usePathname } from "next/navigation";
import React, { useEffect, useState } from "react";
import { useAuthStore } from "../../store/authstore";
import { googleLogout } from "@react-oauth/google";
import { useToastStore } from "../../store/localapi";
import { fetchWithLoader } from "../../utils/api";
import tohash from "../../utils/tohash";
import { normalizeGoogleAvatarUrl } from "../../utils/avatar";
import deviceInfo from "../../utils/deviceInfo";

/* eslint-disable @next/next/no-img-element */
function Header() {
  const user = useAuthStore((state) => state.user);
  // const [query, setQuery] = useState("");
  const logout = useAuthStore((state) => state.logout);
  const { showToast } = useToastStore()

  const [isSticky, setIsSticky] = useState(false);
  const [isClose, setIsClose] = useState(false);
  const pathname = usePathname();

  useEffect(() => {
    // if (typeof window !== "undefined" && window.location.href) {
    //   setQuery(window.location.href.replace('https://dramasstory.com/', '').replace('https://dramaflicksapp.com/', ''))
    // }
    const handleScroll = () => {
      const currentScroll = window.pageYOffset;
      if (currentScroll > 120) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);


  const handleLogout = () => {
    setIsClose(false);
    googleLogout();
    // Facebook logout
    if (typeof window !== 'undefined' && window) {
      // eslint-disable-next-line
      const win = window as any;
      if (win.FB) {
        try {
          {/*eslint-disable-next-line */ }
          win.FB.getLoginStatus((response: any) => {
            if (response.status === 'connected') {
              win.FB.logout();
            }
          });
        } catch (error) {
          console.warn('Facebook logout failed:', error);
        }
      }
    }
    logout();
    const device = deviceInfo()
    if (!user) return;
    const deviceId = tohash(`${device.name}${device.platform}${device.os}${user?.user_email}${device.version}`)

    fetchWithLoader('user_logout_json.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ device_id: deviceId })
    }).then(res => res.json()).then(data => {
      // console.log(data)
      showToast("Logout Successful", "success");
    }).catch(err => {
      console.error(err);
      showToast("Logout Failed", "error");
    });
  };

  // const handleWatchNowClick = async () => {
  //   const currentUrl = window.location.href;
  //   setIsClose(false);
  //   try {
  //     // THIS IS THE PRIMARY AND MOST RELIABLE METHOD ON MODERN BROWSERS (REQUIRES HTTPS!)
  //     await navigator.clipboard.writeText(currentUrl);
  //   } catch (err) {
  //     console.error('Failed to copy using Clipboard API:', err);
  //     // FALLBACK: less reliable, but might work in some edge cases or older browsers
  //     const textArea = document.createElement('textarea');
  //     textArea.value = currentUrl;
  //     textArea.style.position = 'fixed';
  //     textArea.style.left = '-9999px';
  //     textArea.style.top = '-9999px';
  //     document.body.appendChild(textArea);
  //     textArea.focus();
  //     textArea.select(); // Essential for execCommand
  //     try {
  //       document.execCommand('copy');
  //     } catch (execErr) {
  //       console.error('document.execCommand("copy") failed:', execErr);
  //     } finally {
  //       document.body.removeChild(textArea);
  //     }
  //   }
  // };



  const name = (user?.user_name?.length ?? 0) <= 12 && user?.user_name?.trim()
    ? user.user_name :
    user?.user_name && user?.user_name?.trim() && user?.user_name?.length > 12
      ? user?.user_name?.slice(0, 9) + '...'
      : "Guest";

  return (
    <div className="headerSec ">
      <header className={isSticky ? "is-sticky" : ""}>
        <nav className={user ? 'loggedin' : ''}>
          <div className="wrapper">
            <div className="logo">
              <Link href="/" aria-label="DramaFlicks" title="DramaFlicks">
                <img src="https://dramasstory.fra1.cdn.digitaloceanspaces.com/web_images/Logo_new.webp" alt="logo" />
              </Link>
            </div>

            <input type="radio" name="slider" id="menu-btn" checked={!isClose} onChange={() => { }} />

            <div className="nav-links">
              <label onClick={() => setIsClose(false)} htmlFor="menu-btn" className="btn close-btn">
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#FFFFFF"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" /></svg>
              </label>
              <ul className="navMenuslinks">
                {/* <label onClick={() => setIsClose(false)} htmlFor="menu-btn" className="btn close-btn">
                  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#FFFFFF"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg>
                </label> */}
                <li>
                  <Link
                    onClick={() => setIsClose(false)}
                    href="/watchnow"
                    className={`${pathname === "/watchnow" ? "active" : ""}`}
                  >
                    Watch Now
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={() => setIsClose(false)}
                    href="/continueWatch"
                    className={`${pathname === "/continueWatch" ? "active" : ""
                      }`}
                  >
                    Continue Watching{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={() => setIsClose(false)}
                    href="/saveList"
                    className={`${pathname === "/saveList" ? "active" : ""}`}
                  >
                    My List
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={() => setIsClose(false)}
                    href="/premium"
                    className={`${pathname === "/premium" ? "active" : ""}`}
                  >
                    Premium
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={() => setIsClose(false)}
                    href="/rewards"
                    className={`${pathname === "/rewards" ? "active" : ""}`}
                  >
                    Rewards
                  </Link>
                </li>
              </ul>
              <ul className="getbtn">
                <li className="serachbtn">
                  <Link onClick={() => setIsClose(false)} href="/searchfilters" aria-label="Search" type="submit" className="serchIcon" >
                    {/* <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#FFFFFF"><path d="M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Z"/></svg> */}
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                      <path d="M19.7978 18.0673L14.8723 13.1418C17.1084 10.0113 16.8183 5.64186 14.0141 2.83164C10.8897 -0.292839 5.81917 -0.292839 2.68865 2.83164C-0.44188 5.95612 -0.435836 11.0266 2.68865 14.1571C5.50491 16.9734 9.90457 17.2514 13.029 14.9911L17.9484 19.9105C18.4561 20.4182 19.2841 20.4182 19.7917 19.9105C20.2994 19.4029 20.3054 18.5749 19.7978 18.0673ZM4.82804 12.0238C2.88204 10.0778 2.88204 6.92308 4.82804 4.97104C6.77404 3.01899 9.92874 3.02503 11.8808 4.97104C13.8328 6.91704 13.8268 10.0717 11.8808 12.0238C9.93478 13.9758 6.77404 13.9698 4.82804 12.0238Z" fill="white" />
                    </svg>
                  </Link>
                </li>

                <li className="getApp">
                  <div className="dropdownContainer">
                    <div className="logingroup">
                      <Link aria-label="User icons and profile picture" onClick={() => !user && setIsClose(false)} href={`${user && user.user_email ? "/dashboard" : "/login"}`} className={`loginlabel commonBtn  ${user && user.user_email ? 'removeBorder useNme' : ''}`}>
                        <span className="userIcon">
                          <img
                            style={{ display: user?.user_image ? 'block' : 'none' }}
                            src={normalizeGoogleAvatarUrl(user?.user_image) || "/usericonNew.webp"}
                            alt="user"
                            loading="lazy"
                            referrerPolicy="no-referrer"
                            crossOrigin="anonymous"
                            onError={(e) => {
                              const el = e.currentTarget as HTMLImageElement;
                              if (el.dataset.fallbackApplied) return;
                              el.dataset.fallbackApplied = '1';
                              el.src = '/usericonNew.webp';
                            }}
                          />
                          <img style={{ display: user?.user_image ? 'none' : 'block' }} src="/usericonNew.webp" alt="user" loading="lazy" className="userIg" />
                          {user && user?.user_email && user?.premium_data?.premium == "1" && <SVGICON />}
                        </span>
                        <span className="logName">
                          {`${user && user?.user_email ? name : 'Sign In'}`}</span>
                        {user && user?.user_email && <span className="user_icon_arrow">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="9"
                            viewBox="0 0 14 9"
                            fill="none"
                          >
                            <path
                              d="M0.830725 0.693567C1.02629 0.537115 1.24141 0.454 1.47609 0.444222C1.71077 0.434444 1.91611 0.517559 2.09212 0.693567L7.25502 5.85647L12.4473 0.664232C12.6037 0.507781 12.814 0.434444 13.078 0.444222C13.342 0.454 13.5522 0.537115 13.7087 0.693567C13.9042 0.889132 13.9971 1.09936 13.9873 1.32426C13.9776 1.54916 13.8847 1.74962 13.7087 1.92562L7.87105 7.76323C7.77327 7.86101 7.67549 7.92946 7.57771 7.96857C7.47992 8.00769 7.37236 8.02724 7.25502 8.02724C7.13769 8.02724 7.03013 8.00769 6.93234 7.96857C6.83456 7.92946 6.73678 7.86101 6.639 7.76323L0.830725 1.95496C0.654716 1.77895 0.571603 1.57361 0.581381 1.33893C0.591159 1.10425 0.674273 0.889132 0.830725 0.693567Z"
                              fill="white"
                            />
                          </svg>
                        </span>}
                      </Link>

                      {user && user?.user_email && <div className="dropdown">
                        <label>
                          <Link onClick={() => setIsClose(false)} href="/dashboard">Dashboard</Link>
                        </label>
                        <label>
                          <Link onClick={() => setIsClose(false)} href="/editprofile">Edit Profile</Link>
                        </label>
                        <label>
                          <Link href="/login" onClick={handleLogout}>Sign Out</Link>
                        </label>
                      </div>}
                    </div>
                  </div>

                </li>
                <li className="getApp">
                  {/* https://dramaflicksapp.com/getapp.php/?q=${query} onClick={handleWatchNowClick}*/}
                  <Link href={`/getapp`} type="button" className="commonBtn" onClick={() => setIsClose(false)}>
                    Get App
                  </Link>
                </li>
              </ul>
            </div>

            <div className="formob">
              <ul className="mobSearchIcon">
                <li className="serachbtn">
                  <Link onClick={() => setIsClose(false)} href="/searchfilters" type="submit" className="serchIcon" aria-label="search">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                      <path d="M19.7978 18.0673L14.8723 13.1418C17.1084 10.0113 16.8183 5.64186 14.0141 2.83164C10.8897 -0.292839 5.81917 -0.292839 2.68865 2.83164C-0.44188 5.95612 -0.435836 11.0266 2.68865 14.1571C5.50491 16.9734 9.90457 17.2514 13.029 14.9911L17.9484 19.9105C18.4561 20.4182 19.2841 20.4182 19.7917 19.9105C20.2994 19.4029 20.3054 18.5749 19.7978 18.0673ZM4.82804 12.0238C2.88204 10.0778 2.88204 6.92308 4.82804 4.97104C6.77404 3.01899 9.92874 3.02503 11.8808 4.97104C13.8328 6.91704 13.8268 10.0717 11.8808 12.0238C9.93478 13.9758 6.77404 13.9698 4.82804 12.0238Z" fill="white" />
                    </svg>
                  </Link>
                </li>
              </ul>
              <label onClick={() => setIsClose(true)} htmlFor="menu-btn" className="btn menu-btn">
                <span></span>
                <span></span>
                <span></span>
              </label>
            </div>

          </div>
        </nav>
      </header>
    </div>
  );
}

export default Header;



export const SVGICON = () => (<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" className="primiumIg" >
  <circle cx="6.02979" cy="5.76904" r="5.31006" fill="white" />
  <path d="M3.09059 8.35722C3.04834 8.19956 2.50043 5.67682 2.23176 4.43516C2.11885 3.91385 2.5178 3.79138 2.67317 3.93704C2.79747 4.05356 3.5536 4.66521 3.91612 4.95647L5.58634 2.78136C5.79178 2.42554 6.19811 2.51912 6.29522 2.58709C6.3729 2.64147 7.55759 4.18934 8.14023 4.95647C8.44125 4.69755 9.08215 4.14474 9.23752 4.00488C9.43173 3.83006 9.91726 3.8107 9.84929 4.17971C9.79491 4.47491 9.21163 7.12525 8.92678 8.41352C7.9266 9.4137 3.26385 9.00383 3.09059 8.35722Z" fill="#FFCC3F" />
  <path d="M8.13941 4.95611L9.35593 6.47305C9.45446 5.9711 9.73523 4.73512 9.83577 4.27468C9.97375 3.73812 9.38 3.88003 9.26743 3.97854C9.17738 4.05736 8.47171 4.66772 8.13941 4.95611Z" fill="#EFBF39" />
  <path d="M3.91791 4.95539L2.67779 6.49607C2.56585 6.00096 2.32198 4.84714 2.22144 4.3867C2.11145 3.92259 2.50022 3.79008 2.67148 3.93558C2.77037 4.01955 3.65056 4.74159 3.91791 4.95539Z" fill="#EFBF39" />
  <path d="M7.24734 6.27928C7.23886 6.89894 6.27118 8.07883 5.94862 8.0958H5.94013C5.94013 8.0958 5.94013 8.0958 5.93164 8.0958C5.94013 7.57801 5.95711 6.27079 5.96559 6.26231C5.97408 6.25382 6.53432 6.26231 7.00118 6.27079C7.09455 6.27079 7.17095 6.27928 7.24734 6.27928Z" fill="url(#paint0_linear_5333_22)" />
  <path d="M7.24825 6.27949L5.95801 6.97554L5.97498 4.4375H5.98347C6.48429 4.48843 7.24825 5.80413 7.24825 6.27949Z" fill="url(#paint1_linear_5333_22)" />
  <path d="M5.96577 6.26239L5.94031 8.09589H5.93182C5.93182 8.09589 5.93182 8.09589 5.92333 8.09589C5.63473 8.07891 4.65856 6.94147 4.66705 6.25391C5.08298 6.25391 5.96577 6.26239 5.96577 6.26239Z" fill="url(#paint2_linear_5333_22)" />
  <path d="M5.9827 4.42871L5.96572 6.96675L4.66699 6.25372C4.67548 5.77837 5.51583 4.42871 5.96572 4.4372C5.97421 4.42871 5.97421 4.42871 5.9827 4.42871Z" fill="url(#paint3_linear_5333_22)" />
  <path d="M6.69583 6.50877C6.69583 6.86528 6.1271 7.50191 5.94885 7.50191C5.77908 7.50191 5.21036 6.89075 5.21884 6.50028C5.21884 6.22865 5.71117 5.40527 5.96582 5.40527C6.24594 5.41376 6.69583 6.23714 6.69583 6.50877Z" fill="url(#paint4_linear_5333_22)" />
  <path opacity="0.65" d="M5.97467 4.33555C5.63513 4.3016 4.58257 5.74463 4.55711 6.33882C4.53164 6.933 5.55874 8.35906 5.93223 8.37603C6.29723 8.39301 7.29037 7.11126 7.32433 6.40672C7.35828 5.70218 6.44153 4.37799 5.97467 4.33555ZM7.24793 6.2794C7.23944 6.89905 6.27177 8.07894 5.94921 8.09592H5.94072C5.94072 8.09592 5.94072 8.09592 5.93223 8.09592C5.63513 8.07894 4.65897 6.94149 4.66746 6.25393C4.67594 5.77858 5.5163 4.42892 5.96618 4.43741H5.97467H5.98316C6.48398 4.48834 7.24793 5.80405 7.24793 6.2794Z" fill="url(#paint5_linear_5333_22)" />
  <path d="M5.2531 6.5086C5.24461 6.22849 5.5502 5.80407 5.62659 5.89744C5.80485 6.10116 5.68601 6.93302 5.53322 6.95849C5.38043 6.98396 5.26159 6.68686 5.2531 6.5086Z" fill="#FFD7EF" />
  <path d="M5.55872 7.04347C5.50779 7.15382 5.68605 7.34905 5.81338 7.33207C5.9407 7.3151 5.66058 6.83126 5.55872 7.04347Z" fill="#FFD7EF" />
  <defs>
    <linearGradient id="paint0_linear_5333_22" x1="6.12197" y1="6.73813" x2="7.29373" y2="7.85904" gradientUnits="userSpaceOnUse">
      <stop stopColor="#C7001A" />
      <stop offset="0.1111" stopColor="#D1092C" />
      <stop offset="0.3682" stopColor="#E51A4F" />
      <stop offset="0.6096" stopColor="#F32769" />
      <stop offset="0.8272" stopColor="#FC2E79" />
      <stop offset="1" stopColor="#FF317E" />
    </linearGradient>
    <linearGradient id="paint1_linear_5333_22" x1="5.96558" y1="5.90821" x2="8.22047" y2="3.99109" gradientUnits="userSpaceOnUse">
      <stop stopColor="#C7001A" />
      <stop offset="0.3252" stopColor="#DC123F" />
      <stop offset="0.774" stopColor="#F5286C" />
      <stop offset="1" stopColor="#FF317E" />
    </linearGradient>
    <linearGradient id="paint2_linear_5333_22" x1="5.83591" y1="6.72391" x2="4.59068" y2="7.78912" gradientUnits="userSpaceOnUse">
      <stop stopColor="#C7001A" />
      <stop offset="0.1565" stopColor="#CD0524" />
      <stop offset="0.4259" stopColor="#DC1340" />
      <stop offset="0.7737" stopColor="#F5296D" />
      <stop offset="0.8931" stopColor="#FF317E" />
    </linearGradient>
    <linearGradient id="paint3_linear_5333_22" x1="4.82851" y1="5.19064" x2="6.91882" y2="6.129" gradientUnits="userSpaceOnUse">
      <stop stopColor="#FF317E" />
      <stop offset="0.1783" stopColor="#FC2F79" />
      <stop offset="0.3897" stopColor="#F4276B" />
      <stop offset="0.6181" stopColor="#E71C53" />
      <stop offset="0.8568" stopColor="#D40C32" />
      <stop offset="1" stopColor="#C7001A" />
    </linearGradient>
    <linearGradient id="paint4_linear_5333_22" x1="5.96964" y1="5.14205" x2="5.92749" y2="8.33573" gradientUnits="userSpaceOnUse">
      <stop stopColor="#FF4893" />
      <stop offset="0.2511" stopColor="#FE4690" />
      <stop offset="0.4267" stopColor="#F94187" />
      <stop offset="0.5794" stopColor="#F23878" />
      <stop offset="0.7189" stopColor="#E82B62" />
      <stop offset="0.8495" stopColor="#DB1A45" />
      <stop offset="0.9718" stopColor="#CB0523" />
      <stop offset="1" stopColor="#C7001A" />
    </linearGradient>
    <linearGradient id="paint5_linear_5333_22" x1="4.35133" y1="7.93168" x2="6.96723" y2="5.37612" gradientUnits="userSpaceOnUse">
      <stop stopColor="white" />
      <stop offset="0.0435371" stopColor="#F8E5F1" />
      <stop offset="0.1334" stopColor="#ECB6D8" />
      <stop offset="0.2288" stopColor="#E18DC2" />
      <stop offset="0.3282" stopColor="#D869AF" />
      <stop offset="0.4327" stopColor="#D14DA0" />
      <stop offset="0.5441" stopColor="#CB3794" />
      <stop offset="0.6654" stopColor="#C7278B" />
      <stop offset="0.8043" stopColor="#C51E87" />
      <stop offset="1" stopColor="#C41B85" />
    </linearGradient>
  </defs>
</svg>)
